import React from 'react'
import Reserve from '../Components/Reserve'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

const Reservation = () => {
  return (
    <>
    <Header/>
    <Reserve/>
    <Footer/>
    </>
  )
}

export default Reservation
